import { Engine, Entity } from "../../engine/Engine";
import { PointerGestureInterpreter } from "../../input/PointerGestureInterpreter";

/**
 * Canvas üzerinde {@link PointerGestureInterpreter} kurar. `Engine` içinde
 * `begin()` sırası DesignerTransformer’dan önce gelmeli ki capture dinleyicisi önce çalışsın.
 */
export class PointerGestureInterpreterEntity extends Entity {
  private _interpreter?: PointerGestureInterpreter;

  constructor(private readonly _eventTarget?: EventTarget) {
    super();
  }

  get pointerGestures(): PointerGestureInterpreter | undefined {
    return this._interpreter;
  }

  begin(): void {
    if (this._interpreter || !this.engine) return;
    const canvas = this.engine.canvas;
    this._interpreter = new PointerGestureInterpreter({
      target: canvas,
      eventTarget: this._eventTarget,
      emitTo: "internal",
      useCapture: true,
      moveThresholdPx: 4,
    });
  }

  onRemove(_engine: Engine): void {
    this._interpreter?.dispose();
    this._interpreter = undefined;
  }
}
